export class AppConfig {
    public id: number = 0;
    public name: string = '';
    public json_translate_property: string = '';
    public customer_name: string = '';
    public default_active: boolean = false;
}
